/* sp-site.js: behavior for the site-wide sections sp-site-announcement / sp-site-header (menu, rotator, scrolled state).
   Self-contained; ids are sps-* so they never collide with the homepage / join page header. */
(function () {
  'use strict';
  function $(id) { return document.getElementById(id); }
  function init() {
    var hdr = $('sps-hdr'), mb = $('sps-menu-btn'), mnav = $('sps-mnav'), ann = $('sps-ann');
    if (mb && mnav) {
      var setMenu = function (open) {
        if (open && hdr) mnav.style.top = Math.round(hdr.getBoundingClientRect().bottom + 8) + 'px';
        mb.setAttribute('aria-expanded', open ? 'true' : 'false');
        mnav.classList.toggle('open', open);
      };
      mb.addEventListener('click', function () { setMenu(mb.getAttribute('aria-expanded') !== 'true'); });
      mnav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mnav.classList.contains('open')) { setMenu(false); mb.focus(); } });
      document.addEventListener('click', function (e) { if (mnav.classList.contains('open') && !mnav.contains(e.target) && !mb.contains(e.target)) setMenu(false); });
      window.addEventListener('resize', function () { if (window.innerWidth > 1000) setMenu(false); });
    }
    if (ann && ann.querySelectorAll('p').length > 1 && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      setInterval(function () {
        var alt = ann.classList.toggle('alt'), ps = ann.querySelectorAll('p');
        ps[0].setAttribute('aria-hidden', alt ? 'true' : 'false'); ps[1].setAttribute('aria-hidden', alt ? 'false' : 'true');
      }, 4000);
    }
    if (hdr) {
      var tick = false;
      var onScroll = function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; hdr.classList.toggle('is-scrolled', window.scrollY > 80); }); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
